import { CartFlowType } from "view/apps/Exhibitor/pages/Cart/components/Payment/types";

type Params = {
  cartFlowType: CartFlowType;
  quickOrderId?: string | null;
};

const shouldMakeBankTransferPaymentInBrowser = ({
  cartFlowType,
  quickOrderId,
}: Params): boolean =>
  cartFlowType === CartFlowType.created || Boolean(quickOrderId);

export default shouldMakeBankTransferPaymentInBrowser;
